import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export const getCctvSettings = httpsCallable(functions, "getCctvSettings");
export const updateCctvSettings = httpsCallable(functions, "updateCctvSettings");
export const listCctvCameras = httpsCallable(functions, "listCctvCameras");
export const upsertCctvCamera = httpsCallable(functions, "upsertCctvCamera");
export const deleteCctvCamera = httpsCallable(functions, "deleteCctvCamera");
export const startCctvStream = httpsCallable(functions, "startCctvStream");
export const stopCctvStream = httpsCallable(functions, "stopCctvStream");
export const cctvPtzControl = httpsCallable(functions, "cctvPtzControl");
export const captureCctvSnapshot = httpsCallable(functions, "captureCctvSnapshot");
export const listCctvMotionEvents = httpsCallable(functions, "listCctvMotionEvents");
export const refreshCctvCameraHealth = httpsCallable(functions, "refreshCctvCameraHealth");
export const discoverCctvOnvif = httpsCallable(functions, "discoverCctvOnvif");
